var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar-menu"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"page-title-box"},[_c('div',{staticClass:"page-title-left"},[_c('b-breadcrumb',{staticClass:"m-0",staticStyle:{"font-size":"1.1rem"},attrs:{"items":_vm.items}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }